<template>
  <div>
    <v-btn
      @click.prevent="addDocument"
      class="text-xs-center"
      color="purple darken-4"
      outline
      block
    >
      Documentos
    </v-btn>
    <v-dialog v-model="documentDialog" max-width="450px" lazy>
      <v-card class="pa-3">
        <v-card-title class="py-2">
          <v-layout align-center justify-end row fill-height>
            <div class="headline font-weight-bold mx-auto">Documentos</div>
          </v-layout>
        </v-card-title>
        <v-card-text class="ma-0 pa-0">
          <v-list v-if="idDocs?.length > 0" class="ma-0 pa-0">
            <v-list-tile v-for="photo in idDocs" :key="photo.name">
              <v-list-tile-content>
                <v-list-tile-title>
                  <span style="color: #000">{{
                    photo.category.name === "Outros"
                      ? photo.data.name
                      : photo.category.name
                  }}</span>
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action
                ><v-icon
                  size="20"
                  class="ml-2"
                  color="red"
                  @click="showDeleteModal(photo.name)"
                  >mdi-trash-can</v-icon
                >
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <p v-else class="py-2 text-md-center">
            Nenhum documento foi adicionado
          </p>
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn color="primary" text @click="openCategoryDialog()">
              <v-icon class="mr-2">mdi-upload</v-icon> Adicionar
              documento</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDocumentDialog" persistent max-width="400">
      <v-card class="py-3 px-1">
        <v-card-title>
          <div class="title font-weight-bold mx-auto">
            Deseja remover este documento da lista?
          </div>
        </v-card-title>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn color="primary" text @click="undeleteDocument()"
              >Cancelar</v-btn
            >
            <v-btn color="pink darken-1" text @click="deleteDocument()"
              >Remover documento</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="categoryDialog" max-width="400">
      <v-card class="py-3 px-1">
        <v-card-title>
          <div class="title font-weight-bold mx-auto">
            Qual a categoria deste documento?
          </div>
        </v-card-title>
        <v-card-text class="mx-auto pt-0" style="max-width: 80%">
          <v-autocomplete
            v-model="category"
            :items="categories"
            label="Categoria"
            class="purple-input"
            item-text="name"
            return-object
          />
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn color="primary" text @click="pushDocument()"
              >Adicionar documento</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmOverwriteDialog" persistent max-width="400">
      <v-card class="py-3 px-1">
        <v-card-title>
          <div class="title font-weight-bold text-xs-center">
            Tem certeza que deseja sobrescrever {{ selectedDoc }}?
          </div>
        </v-card-title>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn color="primary" text @click="cancelOverwrite()"
              >Cancelar</v-btn
            >
            <v-btn color="pink darken-1" text @click="confirmOverwrite()"
              >Confirmar</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
    <input
      type="file"
      ref="idDoc"
      style="display: none"
      accept="application/pdf,image/*"
      @change="pickedPhotos($event)"
      :key="docKey"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      idDocs: [],
      documentDialog: false,
      deleteDocumentDialog: false,
      categoryDialog: false,
      confirmOverwriteDialog: false,
      color: "",
      snackMessage: "",
      snackbar: false,
      category: null,
      categories_pf: [
        { type: "document_back", name: "Documento Verso" },
        { type: "document_front", name: "Documento Frente" },
        { type: "document_front_and_back", name: "Documento Frente e Verso" },
        { type: "selfie_with_document", name: "Selfie com Documento" },
        { type: "others", name: "Outros" },
      ],
      categories_pj: [
        {
          type: "proof_of_social_responsibility",
          name: "Comprovante de Responsabilidade Social",
        },
        { type: "document_back", name: "Documento Verso" },
        { type: "document_front", name: "Documento Frente" },
        { type: "document_front_and_back", name: "Documento Frente e Verso" },
        { type: "selfie_with_document", name: "Selfie com Documento" },
        { type: "letter_of_attorney", name: "Procuração" },
        { type: "others", name: "Outros" },
      ],
      deleteDocumentSelected: null,
      docKey: 0,
    };
  },
  computed: {
    ...mapState("sales", ["user"]),
    categories() {
      return this.user?.person_type === "pj"
        ? this.categories_pj
        : this.categories_pf;
    },
    selectedDoc() {
      return this.category?.name ? this.category?.name : "";
    },
  },
  methods: {
    pickIdDoc() {
      this.$refs.idDoc.click();
    },
    async pickedPhotos(event) {
      const docFile = event?.target?.files;
      this.idDocs?.push({ category: this.category, data: docFile[0] });
      this.docKey++;
      this.$emit("updateDocList", this.idDocs);
      this.category = null;
      this.snack("Documento adicionado a lista!", "green");
      this.documentDialog = true;
    },
    showDeleteModal(category) {
      this.deleteDocumentSelected = category;
      this.documentDialog = false;
      this.deleteDocumentDialog = true;
    },
    deleteDocument() {
      const index = this.idDocs?.findIndex(
        (item) => item.name == this.deleteDocumentSelected,
      );
      this.idDocs?.splice(index, 1);
      this.$emit("updateDocList", this.idDocs);
      this.deleteDocumentSelected = null;
      this.deleteDocumentDialog = false;
      this.documentDialog = true;
    },
    undeleteDocument() {
      this.deleteDocumentSelected = null;
      this.deleteDocumentDialog = false;
      this.documentDialog = true;
    },
    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
    openCategoryDialog() {
      this.category = null;
      this.categoryDialog = true;
      this.documentDialog = false;
    },
    addDocument() {
      if (!this.idDocs?.length > 0) {
        this.categoryDialog = true;
      } else {
        this.documentDialog = true;
      }
    },
    pushDocument() {
      if (!this.category)
        this.snack("Selecione uma categoria para o documento!", "red");
      const existingDoc = this.idDocs?.find(
        (item) =>
          item.category?.name === this.category?.name &&
          item.category?.name !== "Outros",
      );
      const doc_others = this.idDocs?.find(
        (item) => item.category?.name === "Outros",
      );

      // Se o documento já existe na lista ele é sobrescrito
      if (existingDoc) {
        this.docToDelete = existingDoc;
        this.confirmOverwriteDialog = true;
        this.categoryDialog = false;
        return;
      }
      // Pode haver mais de um documento da categoria"Outros", por isso ele não é sobrescrito
      else if (doc_others) {
        this.categoryDialog = false;
        this.pickIdDoc();
        return;
      }

      this.categoryDialog = false;
      this.pickIdDoc();
    },
    cancelOverwrite() {
      this.category = null;
      this.confirmOverwriteDialog = false;
      this.documentDialog = true;
    },
    confirmOverwrite() {
      const index = this.idDocs?.findIndex(
        (item) => item.category?.name == this.category?.name,
      );
      this.idDocs?.splice(index, 1);
      this.pickIdDoc();
      this.confirmOverwriteDialog = false;
    },
    getDocRule() {
      if (this.idDocs?.length < 1) {
        return { allow: false, message: "Anexe os documentos do membro." };
      }

      if (
        !this.idDocs?.find(
          (item) =>
            item?.category?.name == "Comprovante de Responsabilidade Social",
        )
      ) {
        return {
          allow: false,
          message: "Anexe o Comprovante de Responsabilidade Social.",
        };
      }

      if (
        !this.idDocs?.find(
          (item) => item?.category?.name == "Selfie com Documento",
        )
      ) {
        return { allow: false, message: "Anexe a Selfie com Documento." };
      }

      if (
        !this.idDocs?.find(
          (item) => item?.category?.name == "Documento Frente e Verso",
        )
      ) {
        if (
          !this.idDocs?.find(
            (item) => item?.category?.name == "Documento Verso",
          ) &&
          !this.idDocs?.find(
            (item) => item?.category?.name == "Documento Frente",
          )
        ) {
          return { allow: false, message: "Anexe o Documento Frente e Verso." };
        }

        if (
          this.idDocs?.find(
            (item) => item?.category?.name == "Documento Verso",
          ) &&
          !this.idDocs?.find(
            (item) => item?.category?.name == "Documento Frente",
          )
        ) {
          return { allow: false, message: "Anexe o Documento Frente." };
        }

        if (
          !this.idDocs?.find(
            (item) => item?.category?.name == "Documento Verso",
          ) &&
          this.idDocs?.find(
            (item) => item?.category?.name == "Documento Frente",
          )
        ) {
          return { allow: false, message: "Anexe o Documento Verso." };
        }
      }

      return { allow: true };
    },
  },
};
</script>
